import { User } from "../models";
import { useAppDispatch } from "../store";
import { toggleFormPopOut } from "../store/slices/settings";
import { useState } from "react";
import { Profile } from "../components";
import { userUpdate } from "../api/users";
import BarLoader from "react-spinners/BarLoader";
import Can from "../components/Can";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import { toast } from "react-toastify";
import { updateUser } from "../store/slices/users";

type Props = {
  user: User;
};

export function UserEdit({ user }: Props) {
  const dispatch = useAppDispatch();
  const [userForm, setUser] = useState<User>(user);
  if (user && user.id !== userForm.id) {
    setUser(user);
  }

  const handleChange = (event: any) => {
    const { name, value } = event.target;
    setUser((prevFormData) =>
      prevFormData ? { ...prevFormData, [name]: value } : prevFormData
    );
  };

  const handleCancelClick = () => {
    dispatch(toggleFormPopOut());
  };

  const handleSaveClick = () => {
    if (userForm?.firstName && userForm?.lastName) {
      userUpdate(userForm);
      dispatch(updateUser(userForm));
      toast.success("User updated successfully", { closeOnClick: true });
    } else {
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      {userForm !== null && userForm !== undefined ? (
        <div>
          <div className="profile-pic">
            <Profile imgUrl={userForm.imgUrl} />
          </div>
          <div>
            <span>First Name:</span>
            <input
              name="firstName"
              value={userForm.firstName}
              onChange={handleChange}
            />
          </div>
          <div>
            <span>Last Name:</span>{" "}
            <input
              name="lastName"
              value={userForm.lastName}
              onChange={handleChange}
            />
          </div>
          <div>
            <span>Email:</span> {userForm.email}
          </div>
          <Can I="manage" this={userForm}>
            <div className="save-panel">
              <button onClick={handleSaveClick}>
                <FontAwesomeIcon icon={regular("save")} />
                <span>Save</span>
              </button>
              <button onClick={handleCancelClick}>
                <FontAwesomeIcon icon={solid("xmark")} />
                <span>Cancel</span>
              </button>
            </div>
          </Can>
        </div>
      ) : (
        <BarLoader className="loader" />
      )}
    </div>
  );
}
